import { createContext } from "react";

const FlexPackDetailsContext = createContext({
  flexPack: {},
  updateFlexPack: () => {},
  flexPackStart: null,
  storeFlexPackStart: () => {},
  flexPackEnd: null,
  storeFlexPackEnd: () => {},
  flexPackVisibility: null,
  storeFlexPackVisibility: () => {},
  canPublish: false,
  updateCanPublish: () => {},
  isFlexPackPublished: false,
  updateIsFlexPackPublished: () => {},
  isFlexPackOnsale: false,
  updateIsFlexPackOnsale: () => {},
  isFlexPackSoldout: false,
  updateIsFlexPackSoldout: () => {},
  hasFlexPackEnded: false,
  updateHasEventEnded: () => {},
});

export default FlexPackDetailsContext;
